import { DishIngredient } from "api-types";

/**
 * Whether the dish can be served without this ingredient.
 *
 * Resolved by the menus service across the whole dish tree: an ingredient is
 * removable only when every occurrence of it is optional, so a single mandatory
 * occurrence anywhere keeps it in the dish.
 */
export function isIngredientRemovable(
  ingredient: DishIngredient,
  optionalIngredientIds: string[] | undefined
): boolean {
  return (
    optionalIngredientIds?.includes(ingredient.igfdTaxIngredientId) ?? false
  );
}
